import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-despachos-edit',
  templateUrl: './despachos-edit.component.html',
  styleUrls: ['./despachos-edit.component.css'],
  standalone: false
})
export class DespachosEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/despachos`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Despachos', link: '/despachos' }, { label: 'Edição Despachos' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'despachos',
      // saveNew: '/despachos',
  };

  fields: PoPageDynamicEditField[] = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('despachos').subscribe((data) => {
        this.fields = data;
    });
  }
}
